import { form, AppendixForm } from "./form";
const checkout = form;
const checkoutAppendix = AppendixForm;

const {
  formField: {
    id,
    date,
    sendTo,
    payerName,
    taxID,
    address,
    agency,
    taxRefundDocument,
    taxRefundDate,
    tradeID,
    notificationReceivingAgency,
    receivedDate,
    why,
    chiefAccountant,
    certificateNumber,
    signer,
  },
} = checkout;

const {
  formFieldAppendix: {
    from,
    to,
    payerNameAppendix,
    taxIdAppendix,
    taxAgentNameAppendix,
    taxAgentCodeAppendix,
  },
} = checkoutAppendix;

const initialValues = {
  [id.name]: "",
  [date.name]: "",
  [sendTo.name]: "",
  [payerName.name]: "",
  [taxID.name]: "",
  [address.name]: "",
  [agency.name]: "",
  [taxRefundDocument.name]: "",
  [taxRefundDate.name]: "",
  [tradeID.name]: "",
  [notificationReceivingAgency.name]: "",
  [receivedDate.name]: "",
  [why.name]: "",
  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [signer.name]: "",
  //appendix
  [from.name]: "",
  [to.name]: "",
  [payerNameAppendix.name]: "",
  [taxIdAppendix.name]: "",
  [taxAgentNameAppendix.name]: "",
  [taxAgentCodeAppendix.name]: "",
};

export default initialValues;
